import React from "react";
import "./style.css";
import classNames from "classnames";
export default function LoadingComponent(props) {
    const colorClass = `loading-part loading-part-${props.color == "white" ? "white" : "classic"}`;
    return (React.createElement("div", { className: classNames("loading-container", {
            "loading-container-small": props.size === "small",
        }), style: { paddingTop: props.extraPadding ? "15px" : "" } },
        React.createElement("div", { className: colorClass + " loading-part-first" }),
        React.createElement("div", { className: colorClass + " loading-part-second" }),
        React.createElement("div", { className: colorClass + " loading-part-third" }),
        props.message));
}
